import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-hot-toast";
import { 
  getNotifications as getNotificationsApi

 } from "../../helpers/custom_helper/backend_helper"

export const getNotificationThunk = createAsyncThunk( "get-notifications",async (data, { rejectWithValue }) => {
    try {
      const response = await getNotificationsApi(data);
    
      if (response.success) {
        return response;
      } else {
        toast.error(response.message || "Data failed");
        return rejectWithValue(response.message);
      }
    } catch (error) {
 
      toast.error(error || "Something went wrong");
      return rejectWithValue(error);
    }
  }
);







